import React from "react";

const Shortlisted = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .candidate-card { box-shadow:0 4px 15px rgba(0,0,0,0.08); border-radius:10px; }
      `}</style>

      <h4>Shortlisted</h4>

      <div className="row">
        {[1,2,3,4].map(i => (
          <div key={i} className="col-md-6 mb-3">
            <div className="card p-3 candidate-card">
              <h6>Harold Gaynor</h6>
              <small>harold@email.com</small>

              <div className="row mt-2 small">
                <div className="col">Role: Accountant</div>
                <div className="col">Date: 12 Sep</div>
                <div className="col text-success">Selected</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shortlisted;